import type { IconKey } from 'flow/components/ui-components/Icon';
import { MeetingProviderType } from 'flow/types/Meetings';

// Provider → registered IconKey. Recognised external providers get their brand
// mark, internal meetings get a plain video camera, and everything without a
// brand icon of its own — including webex — falls back to the calendar mark.
const PROVIDER_ICON: Record<MeetingProviderType, IconKey> = {
    teams: 'Teams',
    google_meet: 'googleMeet',
    zoom: 'zoom',
    webex: 'calendar',
    internal: 'video_outlined',
    other: 'calendar',
};

export const providerIconKey = (type: MeetingProviderType): IconKey =>
    PROVIDER_ICON[type] ?? 'calendar';

// Internal meeting links look like `https://<host>/video?room=<code>`; we open
// them inside the app by navigating to the /video route with that room.
export const parseRoomFromLink = (link: string): string | null => {
    try {
        return new URL(link).searchParams.get('room');
    } catch {
        return null;
    }
};

export const isHttpsLink = (link: string): boolean => {
    try {
        return new URL(link).protocol === 'https:';
    } catch {
        return false;
    }
};
